// extracted by mini-css-extract-plugin
export default {"description":"BDrugAdcFieldTable-module_description_bf4370f5"};